import { apiClient } from '../../client'
import endpoints from '../../endpoints'
import { unwrapSingle } from '../../normalize'

// The caller (usePartialImportKml) only ever reads `.name`, to name-diff against the client-parsed
// KML for auto-skip feedback (see summarizePartialImport) — reconciliation after a successful
// import re-fetches the authoritative loteo instead of consuming the created paddocks' geometry
// directly, so the wire type stays intentionally minimal rather than mirroring the full backend
// Paddock echo.
export type PartialImportedPaddock = {
  name: string
}

export type PartialImportResult = {
  paddocksCreated: PartialImportedPaddock[]
}

// v2 additive KML import (spec: farm-subdivision-partial-import). A partial-overlap conflict comes
// back as a 4xx, which apiClient maps to a BusinessEntityError whose `response` is the raw error
// body — so the backend's conflictingFeatureNames reach the caller untouched.
export default async function partialImport({
  farmSubdivisionId,
  file,
  clipFeatureNames = [],
  signal,
}: {
  farmSubdivisionId: string
  file: File
  clipFeatureNames?: string[]
  signal?: AbortSignal
}): Promise<PartialImportResult> {
  const formData = new FormData()
  formData.append('file', file, file.name)
  if (clipFeatureNames.length > 0) {
    formData.append('clipFeatureNames', JSON.stringify(clipFeatureNames))
  }

  const response = await apiClient.post(
    endpoints.v2.farmSubdivisions.partialImport(farmSubdivisionId),
    formData,
    { signal },
  )
  return unwrapSingle<PartialImportResult>(response)
}
